/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Authorized_Apps_SectionInputs */



/**
* | output |
* | --- |
* | "Authorized Apps" |
*
* @param {Profile_Authorized_Apps_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_authorized_apps_section = /** @type {((inputs?: Profile_Authorized_Apps_SectionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Authorized_Apps_SectionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Applications autorisées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicaciones autorizadas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aplicativos autorizados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applicazioni autorizzate")
	return /** @type {LocalizedString} */ ("Authorized Apps")
});